import config from '../../../config.json'
import Button from "../../general/Button";
import Translation from '../../Translation/cont/Translation';

export const PreviewButton = ({hasChanges, cinemaId, printType, printID, landscapeBoolean, printPk, printUpdateRequest, activeWeek}) => (
    hasChanges ? (
        <Button
            className="button button-cancel" 
            transId="save_button"
            onClick={() => printUpdateRequest()}
            hideText={false}
        />
    ): (
        <a
            className="button button-cancel" 
            href={`${pmkinoClientVars.siteURL}/${config.routes.webtoprint.previewpath}/${cinemaId}/${printType}/${printID}/${printPk}/${landscapeBoolean}/${activeWeek}/all`}
            target="_blank"
        >
            <Translation id="button_preview">Vorschau</Translation>
        </a>
    )
)

export const PrintButton = ({buttonTextTransId, currentPrintID, printID, landscapeBoolean, activeWeek, printType, printPk, cinemaId, printFlyerRequest}) => (
    <Button
        className="button button-submit" 
        transId={buttonTextTransId}
        onClick={() => printFlyerRequest(currentPrintID, printID, landscapeBoolean, activeWeek, printType, cinemaId, printPk, 'all')}
        hideText={false}
    />  
)

export const PreviewPrintButtons = ({hasChanges, buttonTextTransId, cinemaId, printType, currentPrintID, printID, printPk, landscapeBoolean, activeWeek, printUpdateRequest, printFlyerRequest}) => (
    <div className="buttons-submit-cancel">
        <PreviewButton
            hasChanges={hasChanges}
            printPk={printPk}
            cinemaId={cinemaId}
            printType={printType}
            printID={printID}
            landscapeBoolean={landscapeBoolean}
            printUpdateRequest={printUpdateRequest}
            activeWeek={activeWeek}
            />
        <PrintButton
            buttonTextTransId={buttonTextTransId}
            currentPrintID={currentPrintID}
            printPk={printPk}
            printID={printID}
            landscapeBoolean={landscapeBoolean}
            activeWeek={activeWeek}
            printType={printType}
            cinemaId={cinemaId}
            printFlyerRequest={printFlyerRequest}
        />
    </div>
)